// extracted by mini-css-extract-plugin
export default {"container":"size-warning_container__xr7No","content":"size-warning_content__2Ll4l","hidden":"size-warning_hidden__CYp+c size-warning_content__2Ll4l"};